import type { Notification } from "core/redux/reducers/notification/notificationReducer.types.ts";

export type DisplayedSnacks = Record<number, number>;

export const hasNewSnacks = (currentSnacks: DisplayedSnacks, newSnacks: Notification[]): boolean =>
  newSnacks.some((snack) => !(Object.keys(currentSnacks) as unknown as number[]).includes(snack.key as number));
